import React, { useState, useEffect } from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaCoins } from 'react-icons/fa';
import NavbarComponent from '../components/NavbarComponent';
import FooterComponent from '../components/FooterComponent';
import styled, { keyframes } from 'styled-components';
import Confetti from 'react-confetti';

// 🎉 Confetti Animation
const ConfettiWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
`;

// 🎈 Coin Bounce Animation
const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
`;

const CoinIcon = styled(FaCoins)`
  font-size: 60px;
  color: #FFB800;
  animation: ${bounce} 1.5s infinite ease-in-out;
`;

// 🎯 Styled Components for Better UI
const StyledContainer = styled(Container)`
  background-color: #fff;
  border-radius: 16px;
  padding: 30px;
  text-align: center;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  margin: auto;
`;

const Heading = styled.h2`
  font-size: 28px;
  font-weight: bold;
  color: #FF7C24;
  margin-bottom: 15px;
`;

const SubText = styled.p`
  font-size: 18px;
  color: #232830;
  font-weight: 500;
  margin-top: 10px;
`;

const CoinText = styled.p`
  font-size: 20px;
  font-weight: bold;
  color: #232830;
  margin-top: 15px;
`;

const StyledButton = styled(Button)`
  background-color: #FF7C24;
  border-color: #FF7C24;
  font-size: 18px;
  font-weight: bold;
  border-radius: 12px;
  padding: 12px 30px;
  margin-top: 20px;
  transition: 0.2s ease-in-out;

  &:hover {
    background-color: #e66a1a;
    border-color: #e66a1a;
  }
`;

const CoinsReward = () => {
  const navigate = useNavigate();

  return (
    <>
      <NavbarComponent />
      <ConfettiWrapper>
        <Confetti numberOfPieces={120} />
      </ConfettiWrapper>

      <StyledContainer>
        {/* 🏆 Success Message */}
        <Heading> 🚀Congratulations</Heading>
        <SubText>🔥 You're Officially part of  <strong>FinTorro Trading and Investing community!</strong></SubText>

        {/* 💰 Coin Drop Animation */}
        <div className="my-3"><CoinIcon /></div>
        <CoinText>🎉 You earned <strong>100 coins</strong> instantly!</CoinText>
        <SubText>Use them for **Pro lessons, AI mentorship, and more!**</SubText>

        {/* 📈 Call-to-Action */}
        <StyledButton onClick={() => navigate('/courses')}>
          Start My First AI Lesson
        </StyledButton>
      </StyledContainer>

      <FooterComponent />
    </>
  );
};

export default CoinsReward;










// import React, { useState, useEffect } from 'react';
// import { Container, Button } from 'react-bootstrap';
// import { useNavigate } from 'react-router-dom';
// import { FaCoins } from 'react-icons/fa';
// import NavbarComponent from '../components/NavbarComponent';
// import FooterComponent from '../components/FooterComponent';
// import styled, { keyframes } from 'styled-components';
// import Confetti from 'react-confetti';

// // 🎉 Confetti Animation
// const ConfettiWrapper = styled.div`
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   pointer-events: none;
// `;

// // 🎈 Coin Bounce Animation
// const bounce = keyframes`
//   0%, 100% { transform: translateY(0); }
//   50% { transform: translateY(-10px); }
// `;

// const CoinIcon = styled(FaCoins)`
//   font-size: 50px;
//   color: #FFB800;
//   animation: ${bounce} 1.5s infinite ease-in-out;
// `;

// // ⏳ Countdown Timer Style
// const CountdownTimer = styled.div`
//   font-size: 18px;
//   font-weight: bold;
//   color: #FF7C24;
//   margin-top: 10px;
// `;

// const CoinsReward = () => {
//   const navigate = useNavigate();
//   const [countdown, setCountdown] = useState(300); // 5 minutes timer

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setCountdown((prev) => (prev > 0 ? prev - 1 : 0));
//     }, 1000);
//     return () => clearInterval(timer);
//   }, []);

//   const formatTime = (seconds) => {
//     const minutes = Math.floor(seconds / 60);
//     const secs = seconds % 60;
//     return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
//   };

//   return (
//     <>
//       <NavbarComponent />
//       <ConfettiWrapper>
//         <Confetti numberOfPieces={150} />
//       </ConfettiWrapper>

//       <Container className="text-center my-5">
//         {/* 🎉 Welcome Message */}
//         <h2 style={{ fontSize: '30px', fontWeight: 'bold', color: '#FF7C24' }}>You're Officially part of Fintorro community. 🚀</h2>
//         {/* <p style={{ fontSize: '18px', color: '#232830', marginTop: '20px' }}>
//           🔥 You’ve just taken your first step toward <strong>financial freedom!</strong>
//         </p> */}

//         {/* 💰 Coin Drop Animation */}
//         <div className="my-3"><CoinIcon /></div>
//         <p style={{ fontSize: '18px', color: '#232830', fontWeight: 'bold' }}>
//           🎉 You earned <strong>100 coins</strong> instantly to spend them later!<br />
//           "Use them for Pro lessons, AI mentorship, and more!"
//         </p>

//         {/* ⏳ Limited-Time Bonus Incentive */}
//         {/* {countdown > 0 && (
//           <>
//             <p style={{ fontSize: '16px', fontWeight: 'bold', color: '#FF7C24' }}>
//               ⏳ Start learning within <strong>{formatTime(countdown)}</strong> to receive <strong>50 bonus coins</strong>!
//             </p>
//             <CountdownTimer>⏳ {formatTime(countdown)}</CountdownTimer>
//           </>
//         )} */}

//         {/* 🤖 AI Mentor Introduction */}
//         {/* <p style={{ fontSize: '16px', color: '#232830', marginTop: '10px' }}>
//           "Meet your <strong>AI mentor</strong> – your guide to smarter trading decisions!"
//         </p> */}

//         {/* 📈 Personalized CTA Options */}
//         <Button
//           onClick={() => navigate('/courses')}
//           style={{
//             backgroundColor: '#FF7C24',
//             borderColor: '#FF7C24',
//             fontSize: '18px',
//             fontWeight: 'bold',
//             borderRadius: '10px',
//             padding: '12px 30px',
//             marginTop: '15px',
//           }}
//         >
//           Start My First AI lesson
//         </Button>

//         {/* 🎟️ Limited Pro Trial Offer
//         <div style={{
//           backgroundColor: '#232830',
//           color: '#FFFFFF',
//           padding: '10px',
//           borderRadius: '8px',
//           marginTop: '20px',
//           display: 'inline-block'
//         }}>
//           🎟️ <strong>Get 3 Days of FinTorro Pro for Free!</strong><br />
//           <Button
//             onClick={() => navigate('/upgrade')}
//             style={{
//               backgroundColor: '#FF7C24',
//               borderColor: '#FF7C24',
//               fontSize: '16px',
//               fontWeight: 'bold',
//               borderRadius: '8px',
//               padding: '8px 20px',
//               marginTop: '10px',
//               color: '#FFFFFF'
//             }}
//           >
//             Unlock Pro Now
//           </Button>
//         </div> */}
//       </Container>

//       <FooterComponent />
//     </>
//   );
// };

// export default CoinsReward;

